import React from 'react';

import { Box, Paper, Typography } from '@mui/material';

import { formatSyncedDay } from '../Assets/utils';

import AccountOpportunityName from './AccountOpportunityName';

interface Props {
  hasOffer: boolean;
  opportunity: App.OpportunityPage;
}

export default function AccountOpportunityTile({ hasOffer, opportunity }: Props) {
  const fields = [
    { label: 'Stage', value: opportunity.opportunity_info?.stagename },
    { label: 'Close Date', value: formatSyncedDay(opportunity.sales_and_forecast?.closedate) },
    { label: 'Owner Full Name', value: opportunity.opportunity_info?.opp_owner_lookup_name__c },
  ];

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <AccountOpportunityName hasOffer={hasOffer} opportunity={opportunity} />
      <Box
        component="dl"
        sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 1, rowGap: 0.5, mt: 1, mb: 0 }}
      >
        {fields.map(({ label, value }) => (
          <React.Fragment key={label}>
            <Typography component="dt" variant="body2" color="text.secondary">
              {label}:
            </Typography>
            <Typography component="dd" variant="body2" sx={{ m: 0 }}>
              {value || '—'}
            </Typography>
          </React.Fragment>
        ))}
      </Box>
    </Paper>
  );
}
